export default {
  GET_DEALER_ZONES: (state) => state.dealer_zones,
  GET_DEALER_ZONE: (state) => state.dealer_zone,
};
